import React from "react";

const PrivacyConsent = () => {
  return (
    <div className="mb-8 bg-white">
      <p className="text-base font-medium text-black  leading-relaxed mb-4">
        I understand and have been provided with a Notice of Health Information
        Privacy Practices, which provides a complete description of health
        information uses and disclosures. I understand that I have the following
        rights and privileges:
      </p>
      <ul className="list-disc font-medium list-inside ml-6 mb-4 text-base text-black  leading-relaxed">
        <li  className="font-medium">The right to review the notice prior to signing this consent</li>
        <li  className="font-medium">The right to object to the use of my health information for directory purposes</li>
        <li className="font-medium">
          The right to request restrictions as to how my health information may
          be used or disclosed to carry out treatment, payment, or healthcare
          operations
        </li>
      </ul>
      <p className="text-base font-medium text-black  leading-relaxed">
        I understand that I may revoke my consent for the use of my health
        information in writing at any time. I also understand that if I revoke
        my permission, Retina Specialty Institute will no longer use or disclose
        medical information about me for the reasons covered by my written
        authorization. Retina Specialty Institute may refuse to treat me as
        permitted by Section 164.506 of the Code of Federal Regulations. By
        signing this document, I acknowledge that I have been provided with a
        copy of this office's Notice of Privacy Practices.
      </p>
      <p className="text-base  font-medium text-black  leading-relaxed my-4 font-semibold">
        Health care operation:
      </p>
      <p className="text-base  font-medium text-black  leading-relaxed">
        We may use and disclose your health information, as needed, to support our business activities.
        For example: Members of the medical staff may use information in your health records to assess
        the care and outcomes in your case and others like it. This information will then be used to
        continually improve the quality and effectiveness of the healthcare and service we provide.
      </p>
      <p className="text-base  font-medium text-black  leading-relaxed font-semibold"> Your health information may include facial recognition software which we encrypt and use for
      internal operational purposes only.</p>
    </div>
  );
};

export default PrivacyConsent;
